import React, { memo } from 'react'
import clsx from 'clsx'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid2'
import Typography from '@mui/material/Typography'
import { FormattedMessage } from 'react-intl'
import MoneyIcon from 'components/icons/blueMoneyIcon.svg'
import ConsignacionIcon from 'components/icons/bluePoliceIcon.svg'
import IconTrust from 'components/icons/blueCarIcon.svg'
import ContainerComponent from 'components/shared/ContainerComponent/ContainerComponent'
import sx from './styles'

const SellItWithClikAuto = ({
  title,
  description,
  sx: sxProp,
  children,
  textLeft,
  showItems,
}) => {
  const items = [
    {
      id: 1,
      icon: (<MoneyIcon style={{
        width: '40px',
        height: '40px',
        fill: '#1F2CAF',
      }}
      />),
      tagText: 'SYC_FAST_TAG_TEXT_1',
      title: 'SYC_FAST_INFO_ITEM_1_TITLE',
      description: 'SYC_FAST_INFO_ITEM_1_DESCRIPTION_VARIANT',
    },
    {
      id: 2,
      icon: (<IconTrust />),
      tagText: 'SYC_FAST_TAG_TEXT_2',
      title: 'SYC_FAST_INFO_ITEM_3_TITLE_VARIANT',
      description: 'SYC_FAST_INFO_ITEM_2_DESCRIPTION_VARIANT',
    },
    {
      id: 3,
      icon: (<ConsignacionIcon />),
      tagText: 'SYC_FAST_TAG_TEXT_3',
      title: 'SYC_FAST_INFO_ITEM_2_TITLE',
      description: 'SYC_FAST_INFO_ITEM_3_DESCRIPTION_VARIANT',
    },
  ]

  const renderItem = (item) => {
    return (
      <Grid
        size={{
          xs: 12,
          lg: 3.8,
        }}
        sx={sx.item}
        container
        key={`item-row-${item.id}`}
      >
        {item?.tagText && (
          <Box sx={sx.tag}>
            <Typography
              variant="caption"
              component="p"
            >
              <FormattedMessage id={item?.tagText} />
            </Typography>
          </Box>

        )}

        {item?.icon && (
          <Grid
            size={12}
            sx={sx.icons}
          >
            {item?.icon}
          </Grid>
        )}

        <Grid
          size={12}
          sx={sx.cardTitle}
        >
          <Typography
            variant="subtitle1"
            component="p"
            sx={sx.title}
          >
            <FormattedMessage id={item?.title} />
          </Typography>
        </Grid>
        <Grid
          size={12}
          sx={sx.cardDescription}
        >
          <Typography
            variant="body1"
            component="p"
          >
            <FormattedMessage id={item?.description} />
          </Typography>
        </Grid>
      </Grid>
    )
  }

  return (
    <Box sx={{
      ...sx.root,
      ...sxProp,
    }}
    >
      <ContainerComponent sx={sx.container}>
        <Grid size={12}>
          <Typography
            sx={sx.title}
            variant="h3"
            className={clsx({ alignText: textLeft })}
          >
            <FormattedMessage id={title} />
          </Typography>

          {description && (
            <Typography
              component="p"
              variant="subtitle1"
              sx={sx.description}
            >
              <FormattedMessage id={description} />
            </Typography>
          )}

        </Grid>

        {showItems && (
          <Grid
            size={12}
            sx={sx.itemContainer}
            gap={0.5}
            justifyContent="space-between"
            container
          >
            {items?.length > 0 && items.map(renderItem)}
          </Grid>

        )}

        <Grid
          size={12}
          pt={2}
          sx={sx.childrenContainer}
        >
          {children}
        </Grid>

      </ContainerComponent>
    </Box>
  )
}

export default memo(SellItWithClikAuto)
